export default __webpack_public_path__ + "static/media/gurukul-full.b213773b.png";